/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthorizationLeadFacility
 */
export interface PalAuthorizationLeadFacility {
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadFacility
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadFacility
     */
    name: string;
}

/**
 * Check if a given object implements the PalAuthorizationLeadFacility interface.
 */
export function instanceOfPalAuthorizationLeadFacility(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function PalAuthorizationLeadFacilityFromJSON(json: any): PalAuthorizationLeadFacility {
    return PalAuthorizationLeadFacilityFromJSONTyped(json, false);
}

export function PalAuthorizationLeadFacilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthorizationLeadFacility {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function PalAuthorizationLeadFacilityToJSON(value?: PalAuthorizationLeadFacility | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

